module.exports = __webpack_public_path__ + "static/media/3-en.27e423c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/3-en.wav
// module id = r+8J
// module chunks = 1